// extracted by mini-css-extract-plugin
export default {"wrapper":"HorizontalBarChart_wrapper__Qo+au","section":"HorizontalBarChart_section__6iwlo"};